import styled from "styled-components"

const ReservationSubContainer = styled.div`
  background-color: ${(props) => props.theme.a_color_gradients.a_light};

  a:hover {
    border: 2px ${(props) => props.theme.a_color_gradients.a_dark} solid;
  }
`

const ReservationTitle = styled.h2`
  &::after {
    background-color: ${(props) => props.theme.a_color_gradients.a_dark};
  }
`

const ReservationInputType = styled.input`
  & + div span:first-of-type:before {
    color: ${(props) => props.theme.a_color_gradients.a_dark};
    box-shadow: 0 0 0 0.18em ${(props) => props.theme.a_color_gradients.a_dark};
  }
  &:focus + div span:first-of-type:before {
    box-shadow: 0 0 0 0.18em ${(props) => props.theme.a_color_gradients.a_dark},
      0 0 0 0.36em black;
  }
`

const StepIcon = styled.p`
  margin-bottom: 0;
  border: 4px solid
    ${(props) =>
      props.active || props.isDone
        ? props.theme.b_color_gradients.b_dark
        : props.theme.a_color_gradients.a_medium};
  color: "black";
  background-color: ${(props) =>
    props.active ? props.theme.b_color_gradients.b_dark : "white"};
`

const StepLine = styled.div`
  background-color: ${(props) =>
    props.active || props.isDone
      ? props.theme.b_color_gradients.b_dark
      : props.theme.a_color_gradients.a_medium};
`

const ReservationPart4Input = styled.input`
  outline: 2px solid rgb(162, 162, 162);
  &:focus {
    outline: 3px solid black;
  }
`

const ReservationPart4TextArea = styled.textarea`
  outline: 2px solid rgb(162, 162, 162);
  &:focus {
    outline: 3px solid black;
  }
`

const ReservationPart5WeekButton = styled.button`
  background-color: ${(props) => props.theme.b_color_gradients.b_dark};
  color: ${(props) => props.theme.d_color_gradients.d_dark};
`

const ReservationPart5WeekDate = styled.div`
  outline: 2px solid rgb(162, 162, 162);
  &::before {
    background-color: ${(props) => props.theme.a_color_gradients.a_dark};
  }
  & p {
    margin: 0;
  }
`

const ReservationPart5WeekDateJourNombre = styled.p`
  color: ${(props) => props.theme.a_color_gradients.a_dark};
`

const ReservationPart5CreneauxDispos = styled.div`
  outline: 2px solid rgb(162, 162, 162);
  color: ${(props) => props.theme.a_color_gradients.a_dark};
  &:hover {
    color: black;
  }
`
const ReservationPart5CreneauxDisposChoisi = styled.div`
  background-color: ${(props) =>
    props.theme.a_color_gradients.a_dark} !important;
  color: white;
  outline: 2px solid black;
`

export {
  ReservationSubContainer,
  ReservationTitle,
  ReservationInputType,
  StepIcon,
  StepLine,
  ReservationPart4Input,
  ReservationPart4TextArea,
  ReservationPart5WeekButton,
  ReservationPart5WeekDate,
  ReservationPart5WeekDateJourNombre,
  ReservationPart5CreneauxDispos,
  ReservationPart5CreneauxDisposChoisi,
}
